module.exports = __webpack_public_path__ + "static/media/wijn-wit-fles.9db7feee.png";